import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import * as Actions from '../actions/common';
import { initialize } from '../actions/root';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import { Routes, Screens } from '../utils/Routes';
import MessageDialog from './MessageDialog';

/**
 * エラーメッセージダイアログコンポーネント
 */
class ErrorMessageDialog extends React.Component<IProps> {
	public render() {
		const {
			open,
			content,
			replacements,
			withLogout,
		} = this.props.errorMessage;
		// SSOでセッションタイムアウトの場合はメッセージを上書き
		if (
			content === 'LGN_E_0002' &&
			this.props.userAttr.loginType === 'SSO'
		) {
			return (
				<MessageDialog
					style={{ zIndex: 2000 }}
					contents={[{ content: 'LGN_E_0003', replacements }]}
					onClickOk={
						withLogout ? this.onCloseWithLogout : this.onClose
					}
					onClose={withLogout ? this.onCloseWithLogout : this.onClose}
					open={open}
					title={i18n.t('ErrorMessageDialog_0001')}
					showCancelButton={false}
				/>
			);
		}
		return (
			<MessageDialog
				style={{ zIndex: 2000 }}
				contents={[{ content, replacements }]}
				onClickOk={withLogout ? this.onCloseWithLogout : this.onClose}
				onClose={withLogout ? this.onCloseWithLogout : this.onClose}
				open={open}
				title={i18n.t('ErrorMessageDialog_0001')}
				showCancelButton={false}
			/>
		);
	}

	/**
	 * ダイアログクローズ
	 */
	protected onClose = () => {
		this.props.onClose();
	};

	/**
	 * ダイアログクローズ（ログアウト）
	 */
	protected onCloseWithLogout = () => {
		this.props.initializeState();
		this.props.onClose();
		let to;
		if (this.props.userAttr.loginType !== 'SSO') {
			to = Routes.getPath(Screens.LOGIN);
		} else {
			to = Routes.getPath(Screens.LOGOUT);
		}
		this.props.pushHistory(to);
		if (this.props.tsqWindow) {
			this.props.tsqWindow.close();
		}
	};
}

const mapStateToProps = (state: IRootState) => ({
	errorMessage: state.common.errorMessage,
	tsqWindow: state.mainMenu.tsqWindow,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	initializeState: () => dispatch(initialize()),
	onClose: () => dispatch(Actions.commonHideErrorMessage({})),
	pushHistory: (path: string) => dispatch(push(path)),
});

// tslint:disable-next-line: no-empty-interface
export interface IErrorMessageDialogProps {
	// nothing
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = IErrorMessageDialogProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ErrorMessageDialog);

export default Connected;



// WEBPACK FOOTER //
// ./src/components/ErrorMessageDialog.tsx